import {
  ICartItemType,
  ISubmitCheckoutResult,
} from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { createAtomWithSafeStorage } from "@/utils/atom/atomStorageUtil";
import {
  GtagActionField,
  IGTagUserData,
} from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/interfaces";

export const checkoutResultAtom =
  createAtomWithSafeStorage<ISubmitCheckoutResult | null>(
    "checkout_result",
    null,
  );

export const checkoutResultDataLayerAtom = createAtomWithSafeStorage<{
  items: ICartItemType[];
  data: GtagActionField;
  shipping_tier: string;
  isPurchaseEventTracked: boolean;
  userdata: IGTagUserData;
} | null>("checkout_result_Data_Layer", null);
